import prestashop from "prestashop";
import $ from "jquery";
import FiltersRangeSliders from "@js/listing/components/filters/FiltersRangeSliders";
class Filters {
  constructor() {
    this.$body = $("body");
    this.setEvents();
    this.rangeSliders = FiltersRangeSliders;
    this.rangeSliders.init();
  }
  setEvents() {
    prestashop.on("updatedProductList", () => {
      prestashop.pageLoader.hideLoader();
      this.rangeSliders.init();
    });
    prestashop.on("updateFacets", () => {
      prestashop.pageLoader.showLoader();
    });
    this.$body.on("click", ".js-search-link", (event) => {
      event.preventDefault();
      prestashop.emit("updateFacets", $(event.target).closest("a").get(0).href);
    });
    this.$body.on("change", '[data-action="search-select"]', ({ target }) => {
      prestashop.emit("updateFacets", $(target).find("option:selected").data("href"));
    });
    this.$body.on("click", ".js-search-filters-clear-all", (event) => {
      prestashop.emit("updateFacets", this.constructor.parseSearchUrl(event));
    });
    this.$body.on("change", "#search_filters input[data-search-url]", (event) => {
      prestashop.emit("updateFacets", this.constructor.parseSearchUrl(event));
    });
    this.$body.on("change", "#search_filters select#voivodeship", (event) => {
      let optionValue = $("#search_filters select#voivodeship option[data-search-url]:selected").val();
      let url = window.location.href;
      if (url.indexOf("?") >= 0) {
        url = url + "&voivodeship=" + optionValue;
      } else {
        url = url + "?voivodeship=" + optionValue;
      }
      prestashop.emit("updateFacets", url);
    });
    this.$body.on("change", "#search_filters select.district", (event) => {
      let optionValue = $("#search_filters select.district:visible option[data-search-url]:selected").val();
      let url = window.location.href;
      if (url.indexOf("?") >= 0) {
        url = url + "&district=" + optionValue;
      } else {
        url = url + "?district=" + optionValue;
      }
      prestashop.emit("updateFacets", url);
    });
    this.$body.on("change", '#search_filters input[name="booking_option[]"]', (event) => {
      let selectedOptions = $('#search_filters input:checked[name="booking_option[]"]');
      let optionValues = "";
      selectedOptions.each(function(index, el) {
        optionValues = optionValues + el.value + "-";
      });
      let url = window.location.href;
      if (url.indexOf("?") >= 0) {
        url = url + "&booking_options=" + optionValues;
      } else {
        url = url + "?booking_options=" + optionValues;
      }
      prestashop.emit("updateFacets", url);
    });
    this.$body.on("change", "#search_filters-2 select#date_type", (event) => {
      let optionValue = $("#search_filters-2 select#date_type option:selected").val();
      let url = window.location.href;
      if (url.indexOf("?") >= 0) {
        url = url + "&type=" + optionValue;
      } else {
        url = url + "?type=" + optionValue;
      }
      prestashop.emit("updateFacets", url);
    });
    this.$body.on("change", "#search_filters #type_buy", (event) => {
      let optionValue = null;
      if ($("#search_filters #type_buy").is(":checked")) {
        optionValue = $("#search_filters #type_buy").val();
      } else {
        optionValue = "";
      }
      let url = window.location.href;
      if (url.indexOf("?") >= 0) {
        url = url + "&type_buy=" + optionValue;
      } else {
        url = url + "?type_buy=" + optionValue;
      }
      prestashop.emit("updateFacets", url);
    });
    this.$body.on("change", "#search_filters #type_rent", (event) => {
      let optionValue = null;
      if ($("#search_filters #type_rent").is(":checked")) {
        optionValue = $("#search_filters #type_rent").val();
      } else {
        optionValue = "";
      }
      let url = window.location.href;
      if (url.indexOf("?") >= 0) {
        url = url + "&type_rent=" + optionValue;
      } else {
        url = url + "?type_rent=" + optionValue;
      }
      prestashop.emit("updateFacets", url);
    });
  }
  static parseSearchUrl(event) {
    if (event.target.dataset.searchUrl !== void 0) {
      return event.target.dataset.searchUrl;
    }
    if ($(event.target).parent()[0].dataset.searchUrl === void 0) {
      throw new Error("Can not parse search URL");
    }
    return $(event.target).parent()[0].dataset.searchUrl;
  }
}
export default Filters;
